  
const hindi = {
  metalbook: "मेटलबुक",
  category: "श्रेणी",
  our: "हमारा",
  home_banner_sub_heading: "Lorem ipsum dolor sit amet, consectetur HI",
};
export default hindi
